import { Input } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { DeviceConfigurationInstance } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-configuration-layout/settings-devices-configuration-layout.model';
import { DeviceConfigurationInfo } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-configuration-list/settings-devices-configuration-list.model';
import { SettingsViewLayout } from 'modules/settings/settings.style';
import { DeviceConfiguration } from '../settings-devices-configuration.style';

interface DeviceConfigurationFormProps {
    deviceConfigurationInstance: DeviceConfigurationInstance;
    onConfigurationChange: <K extends keyof DeviceConfigurationInfo>(
        propertyName: K,
        value: DeviceConfigurationInfo[K]
    ) => void;
}

export const DeviceConfigurationForm: React.FC<DeviceConfigurationFormProps> = ({
    deviceConfigurationInstance,
    onConfigurationChange,
}) => {
    const { t } = useTranslation();
    const MAX_DESCRIPTION_LENGTH = 30;

    return (
        <SettingsViewLayout>
            <DeviceConfiguration>
                <Input
                    name={'description'}
                    placeholder={t(
                        'settings.devices.device-settings-device-config-layout.workflow.tab.edit-configuration.description'
                    )}
                    value={deviceConfigurationInstance?.description || ''}
                    spaceForError
                    showCharCount
                    onChange={(field, value) =>
                        onConfigurationChange(field as keyof DeviceConfigurationInfo, value || '')
                    }
                    label={t(
                        'settings.devices.device-settings-device-config-layout.workflow.tab.edit-configuration.description'
                    )}
                    maxlength={MAX_DESCRIPTION_LENGTH}
                />
            </DeviceConfiguration>
        </SettingsViewLayout>
    );
};
